<template>
  <div>
    <div class="" id="target" v-if="isAdmin">
      <div class="form-row">
        <h3>eService Job List</h3>
      </div>
      <ejs-grid
        :dataSource="jobEvents"
        ref="refjobEvent"
        :created="created"
        :allowSorting="true"
        :allowPaging="true"
        :pageSettings="pageSettings"
        :toolbar="toolbarOptions"
        enablePersistence="true"
        :commandClick="commandClick"
        :allowTextWrap="true"
        :textWrapSettings="wrapSettings"
      >
        <e-columns>
          <e-column headerText="Edit" width="80" textAlign="Left" :commands="commands" />
          <e-column field="jobGroup" width="13%" headerText="Group" textAlign="Left" />
          <e-column field="jobTitle" width="17%" headerText="Title" textAlign="Left" />
          <e-column field="description" width="26%" headerText="Description" textAlign="Left" />
          <e-column field="isActive" width="10%" headerText="Is Active" textAlign="Left" />
          <e-column
            field="startDate"
            width="13%"
            headerText="Start"
            type="date"
            format="MMM dd, yyyy"
            textAlign="Left"
          />
          <e-column
            field="endDate"
            width="13%"
            headerText="End"
            type="date"
            format="MMM dd, yyyy"
            textAlign="Left"
          />
          <e-column field="emailStage" width="18%" headerText="Email Stage" textAlign="Left" />
        </e-columns>
      </ejs-grid>
    </div>
    <div class="" id="target2" v-if="isAdmin">
      <div class="form-row">
        <h3>eService Auto Email List</h3>
      </div>
      <ejs-grid
        :dataSource="autoEmails"
        ref="autoEmailsjobEvent"
        :created="created"
        :allowSorting="true"
        :allowPaging="true"
        :pageSettings="pageSettings"
        :toolbar="toolbarOptions"
        enablePersistence="true"
        :commandClick="commandClick"
        :allowTextWrap="true"
        :textWrapSettings="wrapSettings"
      >
        <e-columns>
          <e-column headerText="Edit" width="80" textAlign="Left" :commands="commands" />
          <e-column field="jobGroup" width="13%" headerText="Group" textAlign="Left" />
          <e-column field="jobTitle" width="16%" headerText="Title" textAlign="Left" />
          <e-column
            field="description"
            width="20%"
            headerText="Description"
            textAlign="Left"
          /><e-column field="isActive" width="10%" headerText="Is Active" textAlign="Left" />
          <e-column field="waitPeriod" width="10%" headerText="Wait Period" textAlign="Left" />
          <e-column
            field="startDate"
            width="13%"
            headerText="Start"
            type="date"
            format="MMM dd, yyyy"
            textAlign="Left"
          />
          <e-column
            field="endDate"
            width="13%"
            headerText="End"
            type="date"
            format="MMM dd, yyyy"
            textAlign="Left"
          />
          <e-column field="emailStage" width="18%" headerText="Email Stage" textAlign="Left" />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from "@syncfusion/ej2-vue-grids";
import { mapGetters } from "vuex";
import { FETCH_JOB_EVENTS } from "../store";

Vue.use(GridPlugin);

export default {
  name: "JobEventList",
  props: {},
  data() {
    return {
      commands: [
        {
          type: "Edit",
          buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" },
        },
      ],
      toolbarOptions: ["Search"],
      pageSettings: { pageSize: 10 },
      target: "#target",
      wrapSettings: { wrapMode: "Content" },
      isAdmin: false,
    };
  },
  computed: {
    ...mapGetters({
      jobEvents: "jobEvents",
      loggedUser: "loggedUser",
      autoEmails: "autoEmails",
    }),
  },
  watch: {
    loggedUser(loggedUser) {
      this.getJobEvents(loggedUser.roles.map((x) => x.roleName));
    },
  },
  created() {
    if (this.loggedUser) {
      this.getJobEvents(this.loggedUser.roles.map((x) => x.roleName));
    }
  },
  mounted() {
    if (this.$refs.refjobEvent) {
      this.$refs.refjobEvent.ej2Instances.searchSettings.key = "";
    }

    if (this.$refs.autoEmailsjobEvent) {
      this.$refs.autoEmailsjobEvent.ej2Instances.searchSettings.key = "";
    }
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.refjobEvent) {
        const refjobEventSearchEle = document.getElementById(
          `${this.$refs.refjobEvent.$el.id}_searchbar`,
        );
        if (refjobEventSearchEle) {
          refjobEventSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refjobEvent.$el.id);
          });
        }
      }

      if (this.$refs.autoEmailsjobEvent) {
        const autoEmailsjobEventSearchEle = document.getElementById(
          `${this.$refs.autoEmailsjobEvent.$el.id}_searchbar`,
        );
        if (autoEmailsjobEventSearchEle) {
          autoEmailsjobEventSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.autoEmailsjobEvent.$el.id);
          });
        }
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove("e-search-icon");
      clearBtnEle.classList.add("e-clear-icon");

      clearBtnEle.addEventListener("click", () => {
        e.target.value = "";
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === "") {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    getJobEvents(roles) {
      this.isAdmin = roles.includes("Admin") || roles.includes("SuperAdmin");
      this.$store.dispatch(FETCH_JOB_EVENTS);
    },
    commandClick(args) {
      if (args.commandColumn.type === "Edit") {
        this.$router.push(`/job-event-edit/${args.rowData.jobId}`);
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>

<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
.e-content .e-item {
  font-size: 12px;
  margin: 10px;
  text-align: justify;
}
.info {
  margin: 10px;
  font-weight: bold;
}

.e-tab .e-content > .e-item.e-active.collapse {
  display: none;
}

.e-tab .e-tab-header .e-indicator.collapse {
  display: none;
}
.e-tab.e-background .e-tab-header {
  background: #0f4b90;
  border: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap {
  background: #0f4b90;
  border-radius: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap {
  background: #0f4b90 !important;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus {
  background: #0f4b90;
}
</style>
